import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../firebase";
import { ADMIN_EMAILS } from "../config/adminConfig";
import { CircularProgress, Box, Typography, Button } from "@mui/material";

interface AdminRouteProps {
  children: React.ReactNode;
}

const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  const { user } = useAuth();
  const [loading, setLoading] = React.useState(true);
  const [isAdmin, setIsAdmin] = React.useState(false);

  React.useEffect(() => {
    if (user) {
      // Check if user's email is in the admin list
      // Convert to lowercase for case-insensitive comparison
      const userEmail = user.email?.toLowerCase();
      const isAuthorized = ADMIN_EMAILS.some(
        (email) => email.toLowerCase() === userEmail
      );
      setIsAdmin(isAuthorized);
    } else {
        setIsAdmin(false);
    }
    setLoading(false);
  }, [user]);

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!user) {
    return <Navigate to="/sign-in" replace />;
  }

  if (!isAdmin) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
          p: 3,
          textAlign: "center",
        }}
      >
        <Typography variant="h4" color="error" gutterBottom>
          Access Denied
        </Typography>
        <Typography variant="body1" paragraph>
          You do not have permission to view this page.
        </Typography>
        <Button variant="contained" color="primary" href="/">
          Go to Home
        </Button>
      </Box>
    );
  }

  return <>{children}</>;
};

export default AdminRoute;
